import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { ABILITIES } from '../../../components/Can'
import {
  getAmenities,
  clearReservations,
  selectAmenities,
} from '../../../reducers/Organisation/reservationsReducer'
import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import { selectUserData, selectUserRole } from '../../../reducers/userDataReducer'
import FeaturedTable from '../../FeaturedTable/FeaturedTable'
import { reservationsAmenitiesColumns } from '../helpers'

import EmptyState from './EmptyState'

const ReservationsAmenities = () => {
  const { t } = useTranslation(['reservations'])
  const [selectedBuilding, setSelectedBuilding] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const amenities = useSelector(selectAmenities)
  const userData = useSelector(selectUserData)
  const building = useSelector(selectActiveBuilding)
  const userRole = useSelector(selectUserRole)

  useEffect(() => {
    if (building && selectedBuilding !== building.id) {
      fetchAmenities()
      setSelectedBuilding(building.id)
    }
  }, [building])

  useEffect(() => {
    if (!ABILITIES.Navbar.reservation_amenities.includes(userData.user.role)) {
      navigate('/')
    }
    return () => {
      dispatch(clearReservations())
    }
  }, [])

  const fetchAmenities = async () => {
    try {
      setIsLoading(true)
      await dispatch(
        getAmenities(
          ['Administrator', 'PropertyManager'].includes(userRole) && building
            ? building.id
            : undefined,
        ),
      )
    } catch ({ message }) {
      console.error(message)
    } finally {
      setIsLoading(false)
    }
  }

  const columns = reservationsAmenitiesColumns(t)

  return (
    <div className="reservations-amenities">
      <div className={`reservations-amenities__table ${isLoading ? 'is-loading' : ''}`}>
        {amenities.length > 0 ? (
          <FeaturedTable columns={columns} data={amenities} />
        ) : (
          <EmptyState />
        )}
      </div>
    </div>
  )
}

ReservationsAmenities.propTypes = {
  userRole: PropTypes.string,
}

export default ReservationsAmenities
